import type { Nullable } from 'common/types'

export const getStringFromNumbersLettersOnly = (text?: Nullable<string>) => {
  return text?.replace(/[^a-zа-я0-9,\s]/gi, '') ?? ''
}
